export default "__VITE_ASSET__CleJwX9f__"